import * as React from "react";
import Panel from "../core/Panel";
import * as moment from "moment";

interface IProps {
  lessons: any
}

interface IState {
}

class CourseLessons extends React.Component<IProps, IState> {
  render() {
    return (
      <Panel heading={"Course Lessons"}>
        {
          this.props.lessons
          ? (
              <table className={"table"}>
                <thead>
                  <tr>
                    <th>Course Title</th>
                    <th>Course Description</th>
                    <th>View Count</th>
                    <th>Comment Count</th>
                    <th>Created Date</th>
                    <th>Updated Date</th>
                  </tr>
                </thead>
                <tbody>
                {
                  this.props.lessons.map((lesson, key) => {
                    return (
                      <tr key={key}>
                        <td>{lesson.title}</td>
                        <td>{lesson.description ? lesson.description : ""}</td>
                        <td>{lesson.view_count}</td>
                        <td>{lesson.comment_count}</td>
                        <td>{moment(lesson.created_at).format('MM/DD/YYYY')}</td>
                        <td>{moment(lesson.updated_at).format('MM/DD/YYYY')}</td>
                      </tr>
                    );
                  })
                }
                </tbody>
              </table>
            )
          : "No lessons"
        }
      </Panel>
    );
  }
}

export default CourseLessons;


// WEBPACK FOOTER //
// ./app/javascript/components/report/CourseLessons.tsx